import { setGA4Event } from "@iewcasia/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/OrderStatus/Handlers/Reorder";

addToChainAfter(chain, ExecuteOnSuccessCallback, props => {
    if (props.apiResult?.cartLines) {
        setGA4Event(props.apiResult?.cartLines, "add_to_cart");
    }
});
